import PropTypes from 'prop-types';
import _ from 'underscore';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    orientation: PropTypes.oneOfType([
        PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
        PropTypes.arrayOf(PropTypes.oneOf(['top', 'bottom', 'right', 'left'])),
    ]),
    scrollable: PropTypes.bool,
    visible: PropTypes.bool,
    manual: PropTypes.bool,
    width: PropTypes.oneOf(['xs', 's', 'l', 'xl', 'full', 'mid', 'full-with-sidebar']),
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    orientation: 'top',
    scrollable: false,
    visible: false,
    manual: false,
    width: 's',
};

class Tooltip extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            orientation,
            scrollable,
            visible,
            manual,
            width,
        } = this.props;
        let orientationClasses = null;
        if (Array.isArray(orientation)) {
            orientationClasses = _.map(orientation, (currentOrientation) => `c-tooltip_${currentOrientation}`);
        } else {
            orientationClasses = `c-tooltip_${orientation}`;
        }
        return [
            'c-tooltip',
            scrollable ? 'c-tooltip__scrollable' : false,
            visible ? 'c-tooltip_visible' : false,
            manual ? 'c-tooltip_manual' : false,
            `c-tooltip_${width}`,
            className,
        ].concat(orientationClasses);
    }

}

Tooltip.propTypes = propTypes;

Tooltip.defaultProps = defaultProps;

export default Tooltip;
